export default __webpack_public_path__ + "static/media/Group8417.3e1d11bd.svg";